import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";

class LatesCustomer {
    name: string;
    products: string[];
    total: number;
}

export class GetInstanceStatCustomerGrowth {
    customers_count = 0;
    visitors_count = 0;
    sale_percent = 0;
    latest_customers: LatesCustomer[];
}

export function getInstanceStatsCustomerGrowth(instance_id: number): Promise<AxiosResponse<GetInstanceStatCustomerGrowth>>{
    return Cirus.get(`/instance/${instance_id}/stats/customer-growth`);
}
// `time_scope=${this.period[0]}&time_scale=${this.period[1]}`


// getDailyTransactions(instance_id) {
	// 	return Cirus.get(`/instance/${instance_id}/report/daily-trans`);
	// }